// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getInputMonitor = createAsyncThunk('getAllInputMonitorSlice/getInputMonitor', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/ScreenTracker/input-monitor?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getUserOption = createAsyncThunk('getAllInputMonitorSlice/getUserOption', async () => {
    try {
        let response = await axios.get('/User?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const inputMonitorSlice = createSlice({
    name: 'getAllInputMonitorSlice',

    initialState: {
        inputMonitor: [],
        userOption: []
    },
    reducers: {
        removeInputMonitor: (state) => {
            state.inputMonitor = [];
        },
        removeUserOption: (state) => {
            state.userOption = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInputMonitor.fulfilled, (state, action) => {
            state.inputMonitor = action?.payload;
            return;
        });
       
        builder.addCase(getUserOption.fulfilled, (state, action) => {
            state.userOption = action?.payload;
            return;
        });
    }
});

export const { removeInputMonitor, removeUserOption } = inputMonitorSlice.actions;
export default inputMonitorSlice.reducer;
